import React, { useEffect, useState } from 'react'
import logo from '../../img/4.png'

import Axios from '../../api/api';

const Weather = () => {
    const [apiData, setApiData] = useState('')

    async function getWeather() {
        await Axios.get('/getWeather/4').then(({ data }) => setApiData(data)).catch(err => console.error(err));
    }

    useEffect(() => {
        let isMounted = true;

        if (isMounted) {
            getWeather();
        }

        return () => {
            isMounted = false
        }
    }, [])

    return (
        <div className="section">
            <div className="section__title__box">
                <h1 className="section__title">Weather Around Your Location</h1>
                <img className="section__title__image" src={logo} alt="sun" />
            </div>
            <div className="content">
                <div className="content__national">
                    <div className="content__picture content__picture__1">
                        &nbsp;
                    </div>
                    <h4 className="content__title content__title__1">
                        <span>Local Level</span>
                    </h4>
                    <div className="content__body">
                        <a target='_blank' href={apiData[0]} className='content__btn'>Alutwewa</a>
                        <a target='_blank' href={apiData[1]} className='content__btn'>Kotaweheramankada</a>
                        <a target='_blank' href={apiData[2]} className='content__btn'>Iyankankulam</a>
                        <a target='_blank' href={apiData[3]} className='content__btn'>Uyilankulam</a>
                        <a target='_blank' href={apiData[4]} className='content__btn'>Puththwedduwan</a>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Weather;